import { Controller } from "@hotwired/stimulus"

// Inventory rarity sub-filter (mobile parity — mobile RarityLegendChip).
//
// Writes the chosen rarity to `data-active-rarity` on the controller element
// (the inventory page root). CSS hides cards whose `data-tier` does not match
// the active rarity. Driven by the single data attribute rather than mutating
// each card, so the filter keeps applying after the equip turbo_stream
// replaces a section's cards (the new cards inherit the CSS rule for free).
//
// Tapping the active rarity again clears it back to "all" — matching the
// mobile toggle behaviour.
export default class extends Controller {
  static targets = ["chip"]

  select(event) {
    const tapped = event.currentTarget.dataset.rarity || "all"
    const current = this.element.dataset.activeRarity || "all"
    const next = tapped !== "all" && tapped === current ? "all" : tapped

    this.element.dataset.activeRarity = next
    this.chipTargets.forEach((chip) => {
      chip.classList.toggle(
        "inv-rarity-chip--active",
        (chip.dataset.rarity || "all") === next,
      )
    })
  }
}
